<template>
    <div
        class="flex flex-col -mt-6 sm:-mt-20"
        :class="isImpersonator ? 'h-[calc(100dvh-144px)]' : 'h-[calc(100dvh-80px)]'"
    >
        <message-hub-navbar v-if="!isMdShortHeight"></message-hub-navbar>

        <div class="flex h-full overflow-hidden gap-3 md:p-3 md:flex-row">
            <div class="flex flex-col grow lg:max-w-xl 2xl:max-w-2xl min-w-0" :class="sidebarClasses">
                <message-hub-navbar v-if="isMdShortHeight"></message-hub-navbar>
                <message-hub-scheduled-messages-sidebar
                    v-if="isScheduledRoute"
                ></message-hub-scheduled-messages-sidebar>
                <message-hub-threads-sidebar v-else></message-hub-threads-sidebar>
            </div>

            <router-view
                class="grow"
                :class="[
                    route.name === 'message-hub' || route.name === 'message-hub.scheduled-messages'
                        ? 'hidden md:flex'
                        : '',
                    route.name === 'message-hub.contact-view' ? 'md:w-2/3' : 'md:w-1/2',
                ]"
            ></router-view>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from 'vue';
import { RouterView, useRoute } from 'vue-router';
import MessageHubNavbar from '~/components/message-hub/MessageHubNavbar.vue';
import { useMessageHub } from '~/components/message-hub/useMessageHub';
import { useResponsiveLayout } from '~/composables/useResponsiveLayout';
import MessageHubThreadsSidebar from '~/components/message-hub/message-hub-threads/MessageHubThreadsSidebar.vue';
import MessageHubScheduledMessagesSidebar from '~/components/message-hub/message-hub-scheduled-messages/MessageHubScheduledMessagesSidebar.vue';

const route = useRoute();
const isImpersonator = Spark.isImpersonating;
const { isMdShortHeight } = useResponsiveLayout();

const { mountMessageHub, isScheduledRoute } = useMessageHub();

onMounted(() => {
    mountMessageHub();

    document.body.classList.add('overflow-hidden');
});

onUnmounted(() => {
    document.body.classList.remove('overflow-hidden');
});

const sidebarClasses = computed(() => {
    if (route.name === 'message-hub.contact-view') {
        return 'hidden lg:flex w-1/3';
    }

    return route.name === 'message-hub' || route.name === 'message-hub.scheduled-messages'
        ? 'flex w-1/2'
        : 'hidden md:flex w-1/2';
});
</script>
